export enum ModalState {
  NONE = 'none',
  ERROR = 'error',
  RSVP = 'rsvp',
  THANK_YOU = 'thankYou',
  SORRY = 'sorry'
}

export interface Guest {
  fullName: string;
  coming?: boolean;
  baby?: boolean;
  young?: boolean;
  side?: string;
  location?: string;
  tags?: string[];
  probability?: string;
  gender?: 'M' | 'F';
  giftEur?: number;
  giftIls?: number;
  giftPhysical?: boolean;
  thanked?: boolean;
  /** Normalized total in EUR for sorting (EUR + ILS / rate). Set by sync. */
  giftValueEur?: number;
}

export interface GuestGroup {
  id: string;
  groupInvite: string;
  rsvpCode?: string;
  /** True for gift-only rows (not on the invite list); no RSVP code is created. */
  giftOnly?: boolean;
  needsBus?: boolean;
  /** @deprecated Legacy Firestore field from per-guest bus count; kept for reads only. */
  busCount?: number;
  language?: string;
  allergies?: string;
  updatedAt?: string;
  guests: Guest[];
} 